import { PRESENTATION, PRESENTATIONSEARCH, AUDIOVIDEO, SCHEDULEINVESTORMEET } from "./type";
import { API_URL } from "../config";
import axios from "axios";

const presentationFn = (data) =>{
    const dt = {...data, IsSuccess:1};
    return{
        type: PRESENTATION,
        payload: dt
    };
}

export const presentationApi = (type) =>{
    let data ={};
    const title = type === 1 ? 'FinancialInformationPresentationPostlist' : 'FinancialInformationPresentationPostlist';
    return (dispatch) =>{
        axios.post(API_URL + title, data).then((response) =>{
            dispatch(presentationFn(response));
        });
    };
}

const presentationsearchFn = (data) =>{
    const dt = {...data, IsSuccess:1};
    return{
        type: PRESENTATIONSEARCH,
        payload: dt
    };
}

export const presentationsearchsearchApi = (cid,yid) =>{
    let data ={category_id:cid, year_id:yid};
    return (dispatch) =>{
        axios.post(API_URL + 'FinancialInformationPresentationSearch', data).then((response) =>{
            if (response.data && response.data.fin_docs) {
                try {
                    let docs = JSON.parse(response.data.fin_docs);
                    if (Array.isArray(docs)) {
                        docs.sort((a, b) => {
                            if (b.id !== a.id) return (b.id || 0) - (a.id || 0);
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                        response.data.fin_docs = JSON.stringify(docs);
                    }
                } catch (e) {}
            }
            dispatch(presentationsearchFn(response));
        });
    };
}
const scheduleInvestorMeetFn = (data) =>{
    const dt = {...data, IsSuccess:1};
    return{
        type: SCHEDULEINVESTORMEET,
        payload: dt
    };
}
export const scheduleInvestorMeetApi = (cid,yid) =>{
    let data ={category_id:cid, year_id:yid};
    return (dispatch) =>{
        axios.post(API_URL + 'ScheduleOfInvestorMeet', data).then((response) =>{
            if (response.data && response.data.fin_docs) {
                try {
                    let docs = JSON.parse(response.data.fin_docs);
                    if (Array.isArray(docs)) {
                        docs.sort((a, b) => {
                            if (b.id !== a.id) return (b.id || 0) - (a.id || 0);
                            return new Date(b.created_at) - new Date(a.created_at);
                        });
                        response.data.fin_docs = JSON.stringify(docs);
                    }
                } catch (e) {}
            }
            dispatch(scheduleInvestorMeetFn(response));
        });
    };
}

const audioVideoFn = (data) =>{
    const dt = {...data, IsSuccess:1};
    return{
        type: AUDIOVIDEO,
        payload: dt
    };
}

export const audioVideoApi = (yid) =>{
    let data ={year_id:yid};
    return (dispatch) =>{
        axios.post(API_URL + 'VideoSearch', data).then((response) =>{
            dispatch(audioVideoFn(response));
        });
    };
}

